module.exports = __webpack_public_path__ + "media/domenj/logosPJRD-ENJ-8bd98c20.png";